import { createSlice } from '@reduxjs/toolkit';

import en from '@/translations/en.json';
import ru from '@/translations/ru.json';

const LANGUAGES = ['en', 'ru'];

const TRANSLATIONS = { en, ru };

const language =
  localStorage?.getItem('govpsfx-language')?.toLowerCase() || 'ru';
const translation = LANGUAGES.includes(language) ? TRANSLATIONS[language] : ru;

const initialState = {
  screenHeight: 600,
  screenWidth: 1280,
  windowScrollY: 0,

  language,
  translation,

  headerView: 'init',

  displayLoader: false,
  displayModal: false,
  displayMenu: false,
  displayProfile: false,

  refCode: '',
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setScreenHeight: (state, action) => {
      state.screenHeight = action.payload;
    },
    setScreenWidth: (state, action) => {
      state.screenWidth = action.payload;
    },
    setWindowScrollY: (state, action) => {
      state.windowScrollY = action.payload;
    },

    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setTranslation: (state, action) => {
      state.translation = action.payload;
    },

    setHeaderView: (state, action) => {
      state.headerView = action.payload;
    },

    setDisplayLoader: (state, action) => {
      state.displayLoader = action.payload;
    },
    setDisplayModal: (state, action) => {
      state.displayModal = action.payload;
    },
    setDisplayMenu: (state, action) => {
      state.displayMenu = action.payload;
    },
    setDisplayProfile: (state, action) => {
      state.displayProfile = action.payload;
    },

    setRefCode: (state, action) => {
      state.refCode = action.payload;
    },

    resetApp: () => initialState,
  },
});

export const {
  setScreenHeight,
  setScreenWidth,
  setWindowScrollY,

  setLanguage,
  setTranslation,

  setHeaderView,

  setDisplayLoader,
  setDisplayModal,
  setDisplayMenu,
  setDisplayProfile,

  setRefCode,

  resetApp,
} = appSlice.actions;

export default appSlice.reducer;
